import React, { useState, useEffect } from "react";
import Select from "react-select";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Modal, Button, Form } from "react-bootstrap";
import HTMLComponent from "../../../../components/HtmlComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import moment from "moment";

const EmployeeList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedState = location.state;
  const [originalData, setOriginalData] = useState([]);
  const [currentOpportunityList, setEmployeeListData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [locationOption, setLocationOption] = useState([]);
  const [jobTitleOption, setJobtitleOption] = useState([]);
  const [statusOption, setStatusOption] = useState([]);

  const columns = {
    Code: { text: "EMP ID", align: "start", type: "Link", visible: true },
    Name: { text: "Employee", align: "left", visible: true },
    MobileNo: { text: "Contact No.", align: "center", visible: true },
    JoiningDate      : { text: "Joining Date", align: "center", visible: true },
    ContactType: { text: "Contact Type", align: "start", visible: false },
    AddedBy: { text: "Added By", align: "left", visible: false },
    Active: { text: "Active", align: "center", visible: true},
    NDASubmittedText: { text: "NDA", align: "center", type: "Modal", visible: false },
    AppointmentLetterSubmittedText: { text: "Appointment Letter", align: "center", type: "Modal", visible: false },
  };
  const defaultColumns = {
    Code: true,
    Name: true,
    MobileNo: true,
    ContactType: true,
    AddedBy: true,
    Active: true,
    NDASubmittedText: false,
    AppointmentLetterSubmittedText: false,
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading(`${passedState ? passedState?.text : "Employee List"} `))
  }, [passedState])

  const handleGetData = () => {
    fetchEmployees();
  };
  const handleResetData = () => {
    setJobTitleValue(0);
    setLocationValue(0);
    setStatusValue(0);
    fetchEmployees();
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    if (originalData.length === 0) return;

    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get('Active');
    const name = queryParams.get('Name');
    const fromDate = queryParams.get('FromDate');
    const toDate = queryParams.get('ToDate');
    const RfromDate = queryParams.get('RfromDate');
    const RtoDate = queryParams.get('RtoDate');
    const filteredData = originalData.filter(item => {
      const joinDate = moment(item.JoiningDate);
      const reliveDate = moment(item.RelivingDate);

      const fromCondition = fromDate
        ? joinDate.isSameOrAfter(moment(fromDate), 'day')
        : true;

      const toCondition = toDate
        ? joinDate.isSameOrBefore(moment(toDate), 'day')
        : true;

      const RfromCondition = RfromDate
        ? reliveDate.isSameOrAfter(moment(RfromDate), 'day')
        : true;

      const RtoCondition = RtoDate
        ? reliveDate.isSameOrBefore(moment(RtoDate), 'day')
        : true;

      const Fstatus = status
        ? item.Active?.trim()?.toLowerCase() === status?.trim()?.toLowerCase()
        : true;

      const Fname = name == "Sub_Contractor"
        ? item.Name?.toLowerCase()?.startsWith(name?.toLowerCase())
        : name == "Employees" ? !item.Name?.toLowerCase()?.startsWith("sub_contractor") : true;

      return fromCondition && toCondition && RtoCondition && RfromCondition && Fstatus && Fname;
    });

    setEmployeeListData(filteredData);
  }, [location.search, originalData]);


  const [apiStatus, SetApiStatus] = useState(undefined)
  const fetchEmployees = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}employee`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status)
        const cleanedData = (response?.data?.candidates || []).map(item => ({
          ...item,
          NDASubmittedText: item.NDASubmitted == 1 
            ? "Submitted" 
            : (item.OnboardingMailsSent == 1 ? "In Process" : "Not Submitted"),
          AppointmentLetterSubmittedText: item.AppointmentLetterSubmitted == 1 
            ? "Submitted" 
            : (item.OnboardingMailsSent == 1 ? "In Process" : "Not Submitted")
        }));
        setEmployeeListData(cleanedData);
        setOriginalData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  const handleEdit = (item) => {
    navigate('/employee-list/rujul/edit/' + item.ID);
  }
  const handleView = (item) => {
    navigate('/employee-list/rujul/view/' + item.ID);
  }
  const handleEmpPayroll = (id) => {
    sessionStorage.setItem('employeeData', JSON.stringify(id));
    navigate(`/employee-list/EmployeePayrolls/edit/${id.ID}`);
  }
  const handleAdd = () => {
    navigate('/employee-list/rujul/add');
  }
  const handleJobDescription = (columnName, item) => {
  };

  const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);
  const [pdfModalTitle, setPdfModalTitle] = useState("");
  const openPdfModal = (url, title) => {
    setSelectedPdfUrl(url);
    setPdfModalTitle(title);
  };
  const closePdfModal = () => {
    setSelectedPdfUrl(null);
    setPdfModalTitle("");
  };

  const handleModalColumn = (columnName, item) => {
    if (columnName === 'NDASubmittedText' && item.NDAPdfUrl) {
      openPdfModal(item.NDAPdfUrl, `NDA - ${item.Name} (${item.Code})`);
    } else if (columnName === 'AppointmentLetterSubmittedText' && item.AppointmentLetterPdfUrl) {
      openPdfModal(item.AppointmentLetterPdfUrl, `Appointment Letter - ${item.Name} (${item.Code})`);
    }
  };

  const [locationValue, setLocationValue] = useState(0);
  const [jobTitleValue, setJobTitleValue] = useState(0);
  const [statusValue, setStatusValue] = useState(0);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const handleApply = () => {
    setShowApplyModal(true);
  };

  const handleApplyModalClose = () => {
    setShowApplyModal(false);
  };
  const [showJDModal, setShowJDModal] = useState(false);
  const [jDId, setJDId] = useState(0);
  const handleJD = (columnName, id) => {
    setShowJDModal(true);
    setJDId(id.ID);
  };
  useEffect(() => {
    if (jDId) {
      fetchJDId(jDId);
    }
  }, [jDId]);
  const handleJDModalClose = () => {
    setShowJDModal(false);
  };
  const [jobDesData, setJobDesData] = useState();
  const fetchJDId = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}jobdescription/${jDId}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.jobdescription?.[0];
        setJobDesData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  const hanldeLinkColumn = (columnName, item) => {
    navigate('/employee-list/rujul/view/' + item.ID);

  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="crad rounded bg-white" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              isAddNewButtonRequired={true}
              data={currentOpportunityList}
              isActionRequired={true}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={false}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              showIcon2={true}
              showIcon3={true}
              hanldeLinkColumn={hanldeLinkColumn}
              handleModalColumn={handleModalColumn}
              handleBtn={() => handleApply()}
              handleIconClick={handleJD}
              handleIcon1={handleEdit}
              handleIcon2={handleView}
              handleIcon3={handleEmpPayroll}
              icons={{
                Icon1: <i class="bi bi-pencil-square"></i>,
                Icon1Text: 'Edit',
                Icon2: <i className="bi bi-eye-fill"></i>,
                Icon2Text: 'View',
                Icon3: <i className="bi bi-wallet2"></i>,
                Icon3Text: 'Employee Payroll',
              }}
              isFilteredRequired={false}
              handleAddNew={handleAdd}
              isAddNewBtnRequired={true}
            />
          </div>
        </div>
      </div>
      <Modal show={showApplyModal} onHide={handleApplyModalClose}>
        <Modal.Header closeButton>
          <Modal.Title className={"text-info"}>{"Confirm"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            <h4>Are you sure you want to apply?</h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-info save-btn"
            type="submit"
          // onClick={handleApplyJob}
          >
            Yes
          </Button>
          <Button
            className="btn-danger save-btn"
            onClick={handleApplyModalClose}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showJDModal}
        onHide={handleJDModalClose}
        dialogClassName="modal-md"
      >
        <div
          style={{ backgroundColor: "#F5F7F8" }}
          className="card rounded border-0 m-2"
        >
          <Modal.Header scloseButton className="p-0 px-3">
            <Modal.Title className="text-info">
              <div className="text-center d-flex justify-center">
                <h2 style={{ fontWeight: '800' }}>Job Description</h2>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            className="rounded m-3 py-0 px-3"
            style={{
              maxHeight: "60vh",
              overflow: "scroll",
              backgroundColor: "white",
            }}
          >
            <div className="">
              <HTMLComponent html={jobDesData} />
            </div>

          </Modal.Body>
          <Modal.Footer className="p-0 px-3">
            <Button className="btn btn-info " onClick={handleJDModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      {selectedPdfUrl && (
        <Modal show={true} onHide={closePdfModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title className="text-info">{pdfModalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <iframe
              src={selectedPdfUrl}
              width="100%"
              height="700px"
              title={pdfModalTitle}
              style={{ border: "none" }}
            ></iframe>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-info save-btn" onClick={closePdfModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default EmployeeList;
